/**
 * Hero Arrow — sizing
 *
 * Stretches the arrow so it reaches the bottom of its hero section. The draw
 * itself is a CSS animation that runs on load (see _block-hero.scss); this only
 * sets the height it animates within.
 */
( function () {
	'use strict';

	var arrows = [];

	var STRETCH_FROM = 768; // px — matches $breakpoint-tablet
	var MIN_HEIGHT   = 80;  // px — below this, keep the CSS size

	// From tablet up the arrow stretches from its anchor down to the bottom of
	// the hero section. Below that it keeps its CSS size.
	function resize( arrow ) {
		var section = arrow.section;

		if ( ! section || window.innerWidth <= STRETCH_FROM ) {
			arrow.el.style.removeProperty( '--hero-arrow-height' );
			return;
		}

		// Measure without the stretch so the anchor point is not affected by a
		// previously applied height.
		arrow.el.style.removeProperty( '--hero-arrow-height' );

		var height = section.getBoundingClientRect().bottom - arrow.el.getBoundingClientRect().top;

		if ( height > MIN_HEIGHT ) {
			arrow.el.style.setProperty( '--hero-arrow-height', height + 'px' );
		}
	}

	function resizeAll() {
		for ( var i = 0; i < arrows.length; i++ ) {
			resize( arrows[ i ] );
		}
	}

	function init() {
		var nodes = document.querySelectorAll( '.hero-arrow' );

		if ( ! nodes.length ) {
			return;
		}

		for ( var i = 0; i < nodes.length; i++ ) {
			arrows.push( {
				el: nodes[ i ],
				section: nodes[ i ].closest ? nodes[ i ].closest( '.hero-section' ) : null
			} );
		}

		resizeAll();
		window.addEventListener( 'resize', resizeAll );

		// The hero graphic settles after load, which can change the section height.
		window.addEventListener( 'load', resizeAll );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
